import { IconButton as ChakraIconButton, Tooltip } from "@chakra-ui/react"
import { Icon } from "components"

export default function IconButton({ label, icon, ...props }){
    return(
    <Tooltip label={label}><ChakraIconButton {...props}><Icon name={icon} /></ChakraIconButton></Tooltip>
    )
}